import React, { forwardRef } from 'react'

import { cn } from 'utils'

import { SolidCircleCheckIcon } from './icons/SolidCircleCheck'
import { TextLikeFormField, type TextLikeFormFieldProps } from './TextLikeFormField'

export interface DateInputProps extends Omit<TextLikeFormFieldProps, 'className' | 'children'>, React.InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
  validated?: boolean;
}

// TODO: Figure out how to replicate "placeholder" styles, given that native
// date inputs don't support the `placeholder` attribute.
export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(({
  validated,
  ...props
}, forwardedRef) => {
  return (
    <TextLikeFormField {...props}>
      {(formFieldProps) => (
        <>
          <input
            {...formFieldProps}
            className={cn(formFieldProps.className, {
              'pr-7': validated,
            })}
            ref={forwardedRef}
            type='date'
            data-testid='date-input'
          />
          {!props.disabled && validated && (
            <div className='flex items-center absolute right-2 top-0 bottom-0 pointer-events-none'>
              <span className='text-green-400'>
                <SolidCircleCheckIcon size={16} />
              </span>
            </div>
          )}
        </>
      )}
    </TextLikeFormField>
  )
})
